// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-popup .leaflet-popup-content-wrapper {
  background: #2c3e50;
  color: #fff;
  font-size: 16px;
  line-height: 24px;
  border-radius: 0px;
}

.custom-popup .leaflet-popup-content-wrapper a {
  color: rgba(255, 255, 255, 0.1);
}

.custom-popup .leaflet-popup-tip-container {
  width: 30px;
  height: 15px;
}

.custom-popup .leaflet-popup-tip {
  background: transparent;
  border: none;
  box-shadow: none;
}

::ng-deep .leaflet-tooltip.track-tooltip {
  width: 200px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.4;
  padding: 6px 10px;
}

:host ::ng-deep .leaflet-overlay-pane {
  z-index: 420 !important;
}
:host ::ng-deep .leaflet-marker-pane {
  z-index: 630 !important;
}

.leaflet {
  height: 100%;
  width: 100%;
  z-index: 1;
}

ion-row {
  align-items: center;
  align-content: center;
}

.row-buttons {
  width: 45%;
  border-radius: var(--border-radius-large);
  background-color: rgba(238, 238, 238, 0.35);
  margin-right: 20%;
}
.row-buttons ion-row {
  padding-left: 6px;
  padding-inline-end: 6px;
}

.waypoint-button-top {
  margin-bottom: var(--spacing-medium);
  margin-top: var(--spacing-small);
}

.label-button-top {
  font-weight: bold;
  width: auto;
  height: 20px;
  --height: 20px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 1;
  word-wrap: break-word;
}

.message-row {
  border-radius: var(--border-radius-large);
  background-color: rgba(238, 203, 47, 0.247);
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.message-label {
  font-size: var(--font-size-medium);
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
  text-align: center;
}

.column-button {
  border-radius: var(--border-radius-large);
  background-color: rgba(238, 238, 238, 0.35);
  margin-top: 18vh;
  max-height: 60vh;
  width: max-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow-y: auto;
}
@media (max-height: 700px) {
  .column-button {
    max-height: 55vh;
  }
}
@media (max-height: 450px) {
  .column-button {
    max-height: 50vh;
  }
}
.column-button ion-row {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 4px;
}
.column-button::-webkit-scrollbar {
  width: 6px;
}
.column-button::-webkit-scrollbar-track {
  margin: var(--border-radius-large) 0;
  background-color: transparent;
}
.column-button::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.label-button-right {
  font-weight: bold;
  text-align: left;
  font-size: var(--font-size-xx-small);
  white-space: nowrap;
  flex: 0 0 auto;
  padding-right: 6px;
}

.label-finish-initial {
  font-size: 10px;
  font-weight: bold;
  width: 80px;
  text-align: right;
}

.general-fab-button {
  --border-radius: 15px;
  --box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
}

.fab-common, .checkNearTracks-fab, .checkUrbanArea-fab, .checkNearInfrastructures-fab {
  position: absolute;
  z-index: 9999;
}
.fab-common ion-fab-button ion-icon, .checkNearTracks-fab ion-fab-button ion-icon, .checkUrbanArea-fab ion-fab-button ion-icon, .checkNearInfrastructures-fab ion-fab-button ion-icon {
  font-size: var(--icon-size-small);
}

.trajectoryCard-button {
  position: absolute;
  width: auto;
  left: 20px;
  top: 20px;
  z-index: 999;
  --background: var(--ion-card-background);
  --padding-start: var(--spacing-large);
  --padding-end: var(--spacing-large);
  --inner-padding-end: var(--spacing-xx-small);
}
.trajectoryCard-button::part(native) {
  border-radius: var(--border-radius-large);
}
.trajectoryCard-button ion-icon {
  font-size: var(--icon-size-medium);
}
.trajectoryCard-button ion-label {
  margin-left: var(--spacing-medium);
  white-space: nowrap;
}

.trajectory-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  position: absolute;
  left: 10px;
  top: 10px;
  bottom: 10px;
  z-index: 100;
}

.trajectory-left-panel {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: var(--ion-card-background);
  opacity: 0.95;
  border-radius: var(--border-radius-large) 0 0 var(--border-radius-large);
  margin: 0;
}

.trajectoryCard-verticalButton {
  flex-shrink: 0;
  width: 20px;
  border-radius: 0 var(--border-radius-large) var(--border-radius-large) 0;
  margin: 0;
  background-color: var(--color-primary-pale);
  opacity: 0.9;
  --padding-start: 0;
  --padding-end: 0;
}
.trajectoryCard-verticalButton ion-icon {
  font-size: var(--icon-size-small);
  color: var(--ion-color-primary);
}

:host-context([data-theme=dark]) .trajectoryCard-verticalButton {
  background-color: var(--color-primary-dark);
}
:host-context([data-theme=dark]) .trajectoryCard-verticalButton ion-icon {
  color: #fff;
}

/** Media queries to set font size and spacing based on screen size **/
/*#region How-to Help Card*/
.help-card {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 101;
  width: 320px;
  max-width: calc(100vw - 40px);
  border: 1px solid rgba(var(--ion-color-warning-rgb), 0.45);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  opacity: 0.95;
}

.help-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 4px 8px 12px;
  background: rgba(var(--ion-color-warning-rgb), 0.22);
  border-bottom: 1px solid rgba(var(--ion-color-warning-rgb), 0.35);
  gap: 8px;
}
.help-card-header .help-card-header-left {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  font-weight: 700;
  color: var(--ion-color-warning-shade);
}
.help-card-header .help-card-header-left ion-icon {
  font-size: 16px;
  color: var(--ion-color-warning-shade);
}

.help-card-close {
  --color: var(--ion-color-warning-shade);
  --padding-start: 4px;
  --padding-end: 4px;
  height: 24px;
  margin: 0;
  flex-shrink: 0;
}

.help-card-body {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 8px 12px 10px;
  background: rgba(var(--ion-color-warning-rgb), 0.07);
}

.help-step {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.help-step-num {
  flex: 0 0 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(var(--ion-color-warning-rgb), 0.35);
  color: var(--ion-color-warning-shade);
  font-size: 10px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.help-step-text {
  font-size: 11px;
  color: var(--ion-color-dark);
  line-height: 1.4;
  flex: 1;
}

/*#endregion*/
@media (max-width: 599px) {
  .trajectory-container {
    width: calc(50% + 20px);
  }
  .checkNearInfrastructures-fab {
    top: unset;
    bottom: 10px;
    left: 90px;
  }
  .checkNearInfrastructures-fab ion-fab-button {
    height: 36px;
    width: 36px;
  }
  .checkUrbanArea-fab {
    top: unset;
    bottom: 10px;
    left: 50px;
  }
  .checkUrbanArea-fab ion-fab-button {
    height: 36px;
    width: 36px;
  }
  .checkNearTracks-fab {
    top: unset;
    bottom: 10px;
    left: 10px;
  }
  .checkNearTracks-fab ion-fab-button {
    height: 36px;
    width: 36px;
  }
  .waypoint-button-top,
  .waypoint-button-right {
    width: 30px;
    height: 30px;
  }
  .waypoint-button-top ion-icon,
  .waypoint-button-right ion-icon {
    font-size: 16px;
  }
  .waypoint-button-right {
    margin: var(--spacing-small);
  }
  .custom-icon {
    width: 24px;
    height: 24px;
  }
  .label-button-top,
  .label-button-right {
    font-size: var(--font-size-xx-small);
  }
  .column-button {
    width: max-content;
  }
  .label-button-right {
    padding-left: var(--spacing-small);
  }
  .trajectoryCard-button {
    left: 10px;
    --min-height: 36px;
  }
  .trajectoryCard-button::part(detail-icon) {
    display: none;
  }
  .help-card {
    display: none;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .trajectory-container {
    width: calc(40% + 20px);
  }
  .checkNearInfrastructures-fab {
    top: 10px;
    right: 210px;
    bottom: unset;
  }
  .checkNearInfrastructures-fab ion-fab-button {
    height: 44px;
    width: 44px;
  }
  .checkUrbanArea-fab {
    top: 10px;
    right: 260px;
    bottom: unset;
  }
  .checkUrbanArea-fab ion-fab-button {
    height: 44px;
    width: 44px;
  }
  .checkNearTracks-fab {
    top: 10px;
    right: 310px;
    bottom: unset;
  }
  .checkNearTracks-fab ion-fab-button {
    height: 44px;
    width: 44px;
  }
  .waypoint-button-top,
  .waypoint-button-right {
    width: 42px;
    height: 42px;
  }
  .waypoint-button-top ion-icon,
  .waypoint-button-right ion-icon {
    font-size: 20px;
  }
  .waypoint-button-right {
    margin: var(--spacing-small);
  }
  .custom-icon {
    width: 32px;
    height: 32px;
  }
  .label-button-top,
  .label-button-right {
    font-size: var(--font-size-xx-small);
  }
  .column-button {
    width: max-content;
  }
  .label-button-right {
    padding-left: var(--spacing-small);
  }
  .trajectoryCard-button {
    left: 15px;
    --min-height: 40px;
  }
  .trajectoryCard-button::part(detail-icon) {
    display: none;
  }
}
@media (min-width: 1024px) {
  .trajectory-container {
    width: calc(33% + 20px);
  }
  .checkNearInfrastructures-fab {
    top: 10px;
    right: 250px;
    bottom: unset;
  }
  .checkNearInfrastructures-fab ion-fab-button {
    height: 50px;
    width: 50px;
  }
  .checkUrbanArea-fab {
    top: 10px;
    right: 310px;
    bottom: unset;
  }
  .checkUrbanArea-fab ion-fab-button {
    height: 50px;
    width: 50px;
  }
  .checkNearTracks-fab {
    top: 10px;
    right: 370px;
    bottom: unset;
  }
  .checkNearTracks-fab ion-fab-button {
    height: 50px;
    width: 50px;
  }
  .waypoint-button-top {
    width: 50px;
    height: 50px;
    margin-bottom: var(--spacing-small);
  }
  .waypoint-button-top ion-icon {
    font-size: 24px;
  }
  .waypoint-button-right {
    width: 50px;
    height: 50px;
    margin: var(--spacing-xx-small);
  }
  .waypoint-button-right ion-icon {
    font-size: 24px;
  }
  .custom-icon {
    width: 40px;
    height: 40px;
  }
  .label-button-top,
  .label-button-right {
    font-size: 10px;
  }
  .column-button {
    width: max-content;
  }
  .label-button-right {
    padding-left: 2px;
  }
  .trajectoryCard-button {
    width: -moz-fit-content;
    width: fit-content;
    --min-height: 48px;
  }
  .trajectoryCard-button::part(detail-icon) {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/trajectory-creation/leaflet-create-trajectory/leaflet-create-trajectory.component.scss","webpack://./src/theme/mocca-breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AADJ;;AAGA;EACI,+BAAA;AAAJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AACA;EACI,uBAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AAEI;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAUE;EACE,uBAAA;AAPJ;AAUE;EACE,uBAAA;AARJ;;AAYA;EACI,YAAA;EACA,WAAA;EACA,UAAA;AATJ;;AAYA;EACE,mBAAA;EACA,qBAAA;AATF;;AAYA;EACE,UAAA;EACA,yCAAA;EACA,2CAAA;EACA,iBAAA;AATF;AAUE;EACE,iBAAA;EACA,uBAAA;AARJ;;AAYA;EACE,oCAAA;EACA,gCAAA;AATF;;AAYA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,qBAAA;AATF;;AAYA;EACE,yCAAA;EACA,2CAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AATF;;AAYA;EACE,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AATF;;AAYA;EACE,yCAAA;EACA,2CAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EAOA,wBAAA;EAAA,mBAAA;EACA,gBAAA;AAfF;AAQE;EANF;IAOI,gBAAA;EALF;AACF;AAME;EATF;IAUI,gBAAA;EAHF;AACF;AAOE;EACE,wBAAA;EACA,8BAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AALJ;AAQE;EACE,UAAA;AANJ;AASE;EACE,oCAAA;EACA,6BAAA;AAPJ;AAUE;EACE,oCAAA;EACA,kBAAA;AARJ;;AAYA;EACE,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AATF;;AAYA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AATF;;AAYA;EACE,qBAAA;EACA,qFAAA;AATF;;AAaA;EACE,kBAAA;EACA,aAAA;AAVF;AAYI;EACE,iCAAA;AAVN;;AAkDA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,wCAAA;EACA,qCAAA;EACA,mCAAA;EACA,4CAAA;AA/CF;AAgDE;EACE,yCAAA;AA9CJ;AAgDE;EACE,kCAAA;AA9CJ;AAgDE;EACE,kCAAA;EACA,mBAAA;AA9CJ;;AAkDA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AA/CF;;AAkDA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,wEAAA;EACA,SAAA;AA/CF;;AAkDA;EACE,cAAA;EACA,WAAA;EACA,wEAAA;EACA,SAAA;EACA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AA/CF;AAgDE;EACE,iCAAA;EACA,+BAAA;AA9CJ;;AAmDE;EACE,2CAAA;AAhDJ;AAiDI;EACE,WAAA;AA/CN;;AAoDA,sEAAA;AAEA,2BAAA;AAEA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,0DAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,aAAA;AAnDF;;AAsDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,oDAAA;EACA,iEAAA;EACA,QAAA;AAnDF;AAqDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;AAnDJ;AAoDI;EACE,eAAA;EACA,qCAAA;AAlDN;;AAuDA;EACE,uCAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AApDF;;AAuDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;EACA,oDAAA;AApDF;;AAuDA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AApDF;;AAuDA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApDF;;AAuDA;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,OAAA;AApDF;;AAuDA,aAAA;ACtVE;ED2VA;IACE,uBAAA;EAvDF;EA0DA;IACE,UAAA;IACA,YAAA;IACA,UAAA;EAxDF;EAhJA;IACE,YAwMkB;IAvMlB,WAuMkB;EArDpB;EAwDA;IACE,UAAA;IACA,YAAA;IACA,UAAA;EAtDF;EAzJA;IACE,YA+MkB;IA9MlB,WA8MkB;EAnDpB;EAsDA;IACE,UAAA;IACA,YAAA;IACA,UAAA;EApDF;EAlKA;IACE,YAsNkB;IArNlB,WAqNkB;EAjDpB;EAoDA;;IAlNA,WAoNgC;IAnNhC,YAmNgC;EAjDhC;EAjKA;;IACE,eAiNoC;EA7CtC;EAgDA;IACE,4BAAA;EA9CF;EAiDA;IAlNA,WAmNqB;IAlNrB,YAkNqB;EA9CrB;EAiDA;;IAEE,oCAAA;EA/CF;EAkDA;IACE,kBAAA;EAhDF;EAmDA;IACE,kCAAA;EAjDF;EAoDA;IACE,UAAA;IACA,kBAAA;EAlDF;EAoDA;IACE,aAAA;EAlDF;EAqDA;IACE,aAAA;EAnDF;AACF;AC9VE;EDqZA;IACE,uBAAA;EApDF;EAuDA;IACE,SAAA;IACA,YAAA;IACA,aAAA;EArDF;EApNA;IACE,YAyQkB;IAxQlB,WAwQkB;EAlDpB;EAqDA;IACE,SAAA;IACA,YAAA;IACA,aAAA;EAnDF;EA7NA;IACE,YAgRkB;IA/QlB,WA+QkB;EAhDpB;EAmDA;IACE,SAAA;IACA,YAAA;IACA,aAAA;EAjDF;EAtOA;IACE,YAuRkB;IAtRlB,WAsRkB;EA9CpB;EAiDA;;IAnRA,WAqRgC;IApRhC,YAoRgC;EA9ChC;EArOA;;IACE,eAkRoC;EA1CtC;EA4CA;IACE,4BAAA;EA1CF;EA6CA;IAlRA,WAmRqB;IAlRrB,YAkRqB;EA1CrB;EA6CA;;IAEE,oCAAA;EA3CF;EA8CA;IACE,kBAAA;EA5CF;EA+CA;IACE,kCAAA;EA7CF;EAgDA;IACE,UAAA;IACA,kBAAA;EA9CF;EAgDA;IACE,aAAA;EA9CF;AACF;ACxZE;ED0cA;IACE,uBAAA;EA/CF;EAkDA;IACE,SAAA;IACA,YAAA;IACA,aAAA;EAhDF;EArRA;IACE,YAqUkB;IApUlB,WAoUkB;EA7CpB;EAgDA;IACE,SAAA;IACA,YAAA;IACA,aAAA;EA9CF;EA9RA;IACE,YA4UkB;IA3UlB,WA2UkB;EA3CpB;EA8CA;IACE,SAAA;IACA,YAAA;IACA,aAAA;EA5CF;EAvSA;IACE,YAmVkB;IAlVlB,WAkVkB;EAzCpB;EA4CA;IA/UA,WAgVgC;IA/UhC,YA+UgC;IAC9B,mCAAA;EAzCF;EAtSA;IACE,eA6UoC;EArCtC;EAyCA;IApVA,WAqVgC;IApVhC,YAoVgC;IAC9B,+BAAA;EAtCF;EA9SA;IACE,eAkVoC;EAlCtC;EAsCA;IAhVA,WAiVqB;IAhVrB,YAgVqB;EAnCrB;EAsCA;;IAEE,eAAA;EApCF;EAuCA;IACE,kBAAA;EArCF;EAwCA;IACE,iBAAA;EAtCF;EAyCA;IACE,uBAAA;IAAA,kBAAA;IACA,kBAAA;EAvCF;EAyCA;IACE,cAAA;EAvCF;AACF","sourcesContent":["@use 'src/theme/mocca-breakpoints' as bp;\r\n\r\n.custom-popup .leaflet-popup-content-wrapper {\r\n    background: #2c3e50;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    border-radius: 0px;\r\n}\r\n.custom-popup .leaflet-popup-content-wrapper a {\r\n    color: rgba(255, 255, 255, 0.1);\r\n}\r\n.custom-popup .leaflet-popup-tip-container {\r\n    width: 30px;\r\n    height: 15px;\r\n}\r\n.custom-popup .leaflet-popup-tip {\r\n    background: transparent;\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n::ng-deep {\r\n    .leaflet-tooltip.track-tooltip {\r\n    width: 200px;\r\n    white-space: normal;\r\n    word-wrap: break-word;\r\n    line-height: 1.4;\r\n    padding: 6px 10px;\r\n  }\r\n}\r\n\r\n// ── Trajectory layer z-ordering ───────────────────────────────────────────────\r\n// Infrastructure zones are drawn into named panes at z-index 400–408.\r\n// Trajectory tracks/regions use the default overlay pane (400) and must be\r\n// raised above all infra panes. Trajectory markers are in the marker pane and\r\n// must also stay clearly above all custom infra panes.\r\n// :host scopes these overrides to the create-trajectory page only.\r\n:host ::ng-deep {\r\n  .leaflet-overlay-pane {\r\n    z-index: 420 !important; // above all infra named panes (400–408)\r\n  }\r\n\r\n  .leaflet-marker-pane {\r\n    z-index: 630 !important; // above shadow (500), well above infra panes\r\n  }\r\n}\r\n\r\n.leaflet {\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 1;\r\n}\r\n\r\nion-row {\r\n  align-items: center;\r\n  align-content: center;\r\n}\r\n\r\n.row-buttons {\r\n  width: 45%;\r\n  border-radius: var(--border-radius-large);\r\n  background-color: rgba(238, 238, 238, 0.350);\r\n  margin-right: 20%;\r\n  ion-row {\r\n    padding-left: 6px;\r\n    padding-inline-end: 6px;\r\n  }\r\n}\r\n\r\n.waypoint-button-top {\r\n  margin-bottom: var(--spacing-medium);\r\n  margin-top: var(--spacing-small);\r\n}\r\n\r\n.label-button-top {\r\n  font-weight: bold;\r\n  width: auto;\r\n  height: 20px;\r\n  --height: 20px;\r\n  text-align: left;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  line-height: 1;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.message-row {\r\n  border-radius: var(--border-radius-large);\r\n  background-color: rgba(238, 203, 47, 0.247);\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.message-label {\r\n  font-size: var(--font-size-medium);\r\n  margin-top: 5px;\r\n  margin-bottom: 5px;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.column-button {\r\n  border-radius: var(--border-radius-large);\r\n  background-color: rgba(238, 238, 238, 0.350);\r\n  margin-top: 18vh;\r\n  max-height: 60vh;\r\n  width: max-content;\r\n  @media (max-height: 700px){\r\n    max-height: 55vh;\r\n  }\r\n  @media (max-height: 450px){\r\n    max-height: 50vh;\r\n  }\r\n  height: fit-content;\r\n  overflow-y: auto;\r\n\r\n  ion-row {\r\n    display: flex !important;\r\n    flex-direction: row !important;\r\n    flex-wrap: nowrap !important;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: 0 4px;\r\n  }\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    margin: var(--border-radius-large) 0;\r\n    background-color: transparent;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n    border-radius: 4px;\r\n  }\r\n}\r\n\r\n.label-button-right {\r\n  font-weight: bold;\r\n  text-align: left;\r\n  font-size: var(--font-size-xx-small);\r\n  white-space: nowrap;\r\n  flex: 0 0 auto;\r\n  padding-right: 6px;\r\n}\r\n\r\n.label-finish-initial {\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n  width: 80px;\r\n  text-align: right;\r\n}\r\n\r\n.general-fab-button {\r\n  --border-radius: 15px;\r\n  --box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n// Common styles for all FABs\r\n.fab-common {\r\n  position: absolute;\r\n  z-index: 9999;\r\n  ion-fab-button {\r\n    ion-icon {\r\n      font-size: var(--icon-size-small);\r\n    }\r\n  }\r\n}\r\n\r\n// Mixin for FAB button sizes\r\n@mixin fab-size($size) {\r\n  ion-fab-button {\r\n    height: $size;\r\n    width: $size;\r\n  }\r\n}\r\n\r\n// Mixin for waypoint button sizes\r\n@mixin waypoint-button-size($size, $icon-size) {\r\n  width: $size;\r\n  height: $size;\r\n  ion-icon {\r\n    font-size: $icon-size;\r\n  }\r\n}\r\n\r\n// Mixin for custom icon sizes\r\n@mixin icon-size($size) {\r\n  width: $size;\r\n  height: $size;\r\n}\r\n\r\n.checkNearInfrastructures-fab {\r\n  @extend .fab-common;\r\n}\r\n\r\n.checkUrbanArea-fab {\r\n  @extend .fab-common;\r\n}\r\n\r\n.checkNearTracks-fab {\r\n  @extend .fab-common;\r\n}\r\n\r\n.trajectoryCard-button {\r\n  position: absolute;\r\n  width: auto;\r\n  left: 20px;\r\n  top: 20px;\r\n  z-index: 999;\r\n  --background: var(--ion-card-background);\r\n  --padding-start: var(--spacing-large);\r\n  --padding-end: var(--spacing-large);\r\n  --inner-padding-end: var(--spacing-xx-small);\r\n  &::part(native) {\r\n    border-radius: var(--border-radius-large);\r\n  }\r\n  ion-icon {\r\n    font-size: var(--icon-size-medium);\r\n  }\r\n  ion-label{\r\n    margin-left: var(--spacing-medium);\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n.trajectory-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: stretch;\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 10px;\r\n  bottom: 10px;\r\n  z-index: 100;\r\n}\r\n\r\n.trajectory-left-panel {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: var(--ion-card-background);\r\n  opacity: 0.95;\r\n  border-radius: var(--border-radius-large) 0 0 var(--border-radius-large);\r\n  margin: 0;\r\n}\r\n\r\n.trajectoryCard-verticalButton {\r\n  flex-shrink: 0;\r\n  width: 20px;\r\n  border-radius: 0 var(--border-radius-large) var(--border-radius-large) 0;\r\n  margin: 0;\r\n  background-color: var(--color-primary-pale);\r\n  opacity: 0.9;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n  ion-icon {\r\n    font-size: var(--icon-size-small);\r\n    color: var(--ion-color-primary);\r\n  }\r\n}\r\n\r\n:host-context([data-theme=\"dark\"]) {\r\n  .trajectoryCard-verticalButton {\r\n    background-color: var(--color-primary-dark);\r\n    ion-icon {\r\n      color: #fff;\r\n    }\r\n  }\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region How-to Help Card*/\r\n\r\n.help-card {\r\n  position: absolute;\r\n  bottom: 16px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 101;\r\n  width: 320px;\r\n  max-width: calc(100vw - 40px);\r\n  border: 1px solid rgba(var(--ion-color-warning-rgb), 0.45);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\r\n  opacity: 0.95;\r\n}\r\n\r\n.help-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 8px 4px 8px 12px;\r\n  background: rgba(var(--ion-color-warning-rgb), 0.22);\r\n  border-bottom: 1px solid rgba(var(--ion-color-warning-rgb), 0.35);\r\n  gap: 8px;\r\n\r\n  .help-card-header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 7px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    color: var(--ion-color-warning-shade);\r\n    ion-icon {\r\n      font-size: 16px;\r\n      color: var(--ion-color-warning-shade);\r\n    }\r\n  }\r\n}\r\n\r\n.help-card-close {\r\n  --color: var(--ion-color-warning-shade);\r\n  --padding-start: 4px;\r\n  --padding-end: 4px;\r\n  height: 24px;\r\n  margin: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.help-card-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  padding: 8px 12px 10px;\r\n  background: rgba(var(--ion-color-warning-rgb), 0.07);\r\n}\r\n\r\n.help-step {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n}\r\n\r\n.help-step-num {\r\n  flex: 0 0 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background: rgba(var(--ion-color-warning-rgb), 0.35);\r\n  color: var(--ion-color-warning-shade);\r\n  font-size: 10px;\r\n  font-weight: 800;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.help-step-text {\r\n  font-size: 11px;\r\n  color: var(--ion-color-dark);\r\n  line-height: 1.4;\r\n  flex: 1;\r\n}\r\n\r\n/*#endregion*/\r\n\r\n// #region Breakpoints (usando mixins de accord-breakpoints.scss)\r\n\r\n@include bp.mobile {\r\n  .trajectory-container {\r\n    width: calc(50% + 20px);\r\n  }\r\n\r\n  .checkNearInfrastructures-fab {\r\n    top: unset;\r\n    bottom: 10px;\r\n    left: 90px;\r\n    @include fab-size(36px);\r\n  }\r\n\r\n  .checkUrbanArea-fab {\r\n    top: unset;\r\n    bottom: 10px;\r\n    left: 50px;\r\n    @include fab-size(36px);\r\n  }\r\n\r\n  .checkNearTracks-fab {\r\n    top: unset;\r\n    bottom: 10px;\r\n    left: 10px;\r\n    @include fab-size(36px);\r\n  }\r\n\r\n  .waypoint-button-top,\r\n  .waypoint-button-right {\r\n    @include waypoint-button-size(30px, 16px);\r\n  }\r\n\r\n  .waypoint-button-right {\r\n    margin: var(--spacing-small);\r\n  }\r\n\r\n  .custom-icon {\r\n    @include icon-size(24px);\r\n  }\r\n\r\n  .label-button-top,\r\n  .label-button-right {\r\n    font-size: var(--font-size-xx-small);\r\n  }\r\n\r\n  .column-button {\r\n    width: max-content;\r\n  }\r\n\r\n  .label-button-right {\r\n    padding-left: var(--spacing-small);\r\n  }\r\n\r\n  .trajectoryCard-button {\r\n    left: 10px;\r\n    --min-height: 36px;\r\n  }\r\n  .trajectoryCard-button::part(detail-icon) {\r\n    display: none;\r\n  }\r\n\r\n  .help-card {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@include bp.tablet {\r\n  .trajectory-container {\r\n    width: calc(40% + 20px);\r\n  }\r\n\r\n  .checkNearInfrastructures-fab {\r\n    top: 10px;\r\n    right: 210px;\r\n    bottom: unset;\r\n    @include fab-size(44px);\r\n  }\r\n\r\n  .checkUrbanArea-fab {\r\n    top: 10px;\r\n    right: 260px;\r\n    bottom: unset;\r\n    @include fab-size(44px);\r\n  }\r\n\r\n  .checkNearTracks-fab {\r\n    top: 10px;\r\n    right: 310px;\r\n    bottom: unset;\r\n    @include fab-size(44px);\r\n  }\r\n\r\n  .waypoint-button-top,\r\n  .waypoint-button-right {\r\n    @include waypoint-button-size(42px, 20px);\r\n  }\r\n  .waypoint-button-right {\r\n    margin: var(--spacing-small);\r\n  }\r\n\r\n  .custom-icon {\r\n    @include icon-size(32px);\r\n  }\r\n\r\n  .label-button-top,\r\n  .label-button-right {\r\n    font-size: var(--font-size-xx-small);\r\n  }\r\n\r\n  .column-button {\r\n    width: max-content;\r\n  }\r\n\r\n  .label-button-right {\r\n    padding-left: var(--spacing-small);\r\n  }\r\n\r\n  .trajectoryCard-button {\r\n    left: 15px;\r\n    --min-height: 40px;\r\n  }\r\n  .trajectoryCard-button::part(detail-icon) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@include bp.desktop {\r\n  .trajectory-container {\r\n    width: calc(33% + 20px);\r\n  }\r\n\r\n  .checkNearInfrastructures-fab {\r\n    top: 10px;\r\n    right: 250px;\r\n    bottom: unset;\r\n    @include fab-size(50px);\r\n  }\r\n\r\n  .checkUrbanArea-fab {\r\n    top: 10px;\r\n    right: 310px;\r\n    bottom: unset;\r\n    @include fab-size(50px);\r\n  }\r\n\r\n  .checkNearTracks-fab {\r\n    top: 10px;\r\n    right: 370px;\r\n    bottom: unset;\r\n    @include fab-size(50px);\r\n  }\r\n\r\n  .waypoint-button-top {\r\n    @include waypoint-button-size(50px, 24px);\r\n    margin-bottom: var(--spacing-small);\r\n  }\r\n\r\n  .waypoint-button-right {\r\n    @include waypoint-button-size(50px, 24px);\r\n    margin: var(--spacing-xx-small);\r\n  }\r\n\r\n  .custom-icon {\r\n    @include icon-size(40px);\r\n  }\r\n\r\n  .label-button-top,\r\n  .label-button-right {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .column-button {\r\n    width: max-content;\r\n  }\r\n\r\n  .label-button-right {\r\n    padding-left: 2px;\r\n  }\r\n\r\n  .trajectoryCard-button {\r\n    width: fit-content;\r\n    --min-height: 48px;\r\n  }\r\n  .trajectoryCard-button::part(detail-icon) {\r\n    display: block;\r\n  }\r\n}\r\n// #endregion Breakpoints\r\n","// =============================================================================\r\n//  accord-breakpoints.scss\r\n//\r\n//  Standard 3-tier Responsive Breakpoints for the Accord Design System.\r\n//  Based on Google Material Design 3 guidelines.\r\n//\r\n//  Breakpoints:\r\n//    Mobile  — max-width: 599px\r\n//    Tablet  — min-width: 600px and max-width: 1023px\r\n//    Desktop — min-width: 1024px\r\n//\r\n//  Usage in component SCSS (with @use):\r\n//    @use 'src/theme/mocca-breakpoints' as bp;\r\n//    @include bp.mobile  { ... }\r\n//    @include bp.tablet  { ... }\r\n//    @include bp.desktop { ... }\r\n//\r\n//  Or via raw @media (legacy/global):\r\n//    @media (max-width: 599px)                        { ... }  // mobile\r\n//    @media (min-width: 600px) and (max-width: 1023px){ ... }  // tablet\r\n//    @media (min-width: 1024px)                       { ... }  // desktop\r\n// =============================================================================\r\n\r\n/// Mobile only — screens ≤ 599px\r\n@mixin mobile {\r\n  @media (max-width: 599px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet only — screens 600px–1023px\r\n@mixin tablet {\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and above — screens ≥ 1024px\r\n@mixin desktop {\r\n  @media (min-width: 1024px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet and above — screens ≥ 600px (tablet + desktop)\r\n@mixin tablet-up {\r\n  @media (min-width: 600px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and below — screens ≤ 1023px (mobile + tablet)\r\n@mixin desktop-down {\r\n  @media (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
